import React from 'react'
import {CustomerInfo, CustomerStatistic} from '/app/src/container'
import {Flex} from '/app/src/component'

class AssignedOverview extends React.Component {
    render(){
        const customer = this.props.customer;
        return (
            <Flex column w='100%' overflowX='hidden' overflowY='auto'>
                 <CustomerInfo customer={customer}/>
                 <CustomerStatistic customer={customer} interval={30000}/>
            </Flex>
        );
    }
}

export default AssignedOverview;



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/Conversation/Assigned/Overview.js